export enum ChatMessageStreamEventType {
  CONTENT_RECEIVED,
  COMPLETED,
}

type ContentReceivedListener = (fragment: string) => void;
type CompletedListener = () => void;

export class ChatMessageStream {
  private contentReceivedListeners: ContentReceivedListener[];
  private completedListeners: CompletedListener[];
  public content: string;
  public completed: boolean;
  public metadata: string;
  public externalId: string;
  public lastChunk: string;

  constructor(initialContent?: string) {
    this.contentReceivedListeners = [];
    this.completedListeners = [];
    this.content = initialContent || "";
    this.metadata = "";
    this.completed = false;
    this.externalId = "";
    this.lastChunk = "";

    this.receiveContent = this.receiveContent.bind(this);
    this.complete = this.complete.bind(this);
  }

  addEventListener(eventType: ChatMessageStreamEventType, listener: ContentReceivedListener | CompletedListener): void {
    if (eventType === ChatMessageStreamEventType.CONTENT_RECEIVED) {
      this.contentReceivedListeners.push(listener as ContentReceivedListener);
    } else if (eventType === ChatMessageStreamEventType.COMPLETED) {
      this.completedListeners.push(listener as CompletedListener);
    }
  }

  removeEventListener(eventType: ChatMessageStreamEventType, listener: ContentReceivedListener | CompletedListener): void {
    if (eventType === ChatMessageStreamEventType.CONTENT_RECEIVED) {
      this.contentReceivedListeners = this.contentReceivedListeners.filter((l) => l !== listener);
    } else if (eventType === ChatMessageStreamEventType.COMPLETED) {
      this.completedListeners = this.completedListeners.filter((l) => l !== listener);
    }
  }

  receiveContent(chunk: string): void {
    this.contentReceivedListeners.forEach((listener) => listener(chunk));
    this.lastChunk = chunk;
    this.content += chunk;
  }

  receiveMetadata(metadata: string): void {
    this.metadata = metadata;
  }

  complete(completeMessage: string, messageExternalId?: string): void {
    this.content = completeMessage;
    this.externalId = messageExternalId || "";
    this.completed = true;

    this.completedListeners.forEach((listener) => listener());
  }
}
